import { render } from "./ImportFileDialog.vue?vue&type=template&id=8913286c"
import script from "./ImportFileDialog.vue?vue&type=script&lang=js"
export * from "./ImportFileDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__